import "./style.scss"
import {ReactComponent as LinkArrow} from "assets/icons/linkArrow.svg";
import {Link} from "react-router-dom";

const TableTop = ({title=null, description=null, redirect=null}) => {
  return <div className="tableTop">
    <div className="upper">
      <p>{title}</p>
      {redirect && <Link> <LinkArrow/> </Link>}
    </div>
    <p className="lower">{description}</p>
  </div>
}

export default TableTop;